// lib/message-bubble-utils.ts

export const parseMarkdownTable = (tableText: string): { headers: string[]; rows: string[][] } => {
  const lines = tableText.trim().split('\n');
  
  if (lines.length < 2) {
    return { headers: [], rows: [] };
  }

  // Parse headers
  const headers = lines[0]
    .split('|')
    .map(h => h.trim())
    .filter(h => h.length > 0);

  // Parse rows (skip separator line)
  const rows = lines
    .slice(2)
    .map(line => 
      line
        .split('|')
        .map(cell => cell.trim())
        .filter(cell => cell.length > 0)
    )
    .filter(row => row.length > 0);

  return { headers, rows };
};